<h2 class="flex justify-center text-center text-2xl">{{ data.title | translatei18n}}</h2>
<mat-dialog-content *ngIf="data.type == 'question'" class="flex flex-row justify-center text-center text-lg mt-4">
  {{ data.question | translatei18n }}</mat-dialog-content>
<mat-dialog-actions  *ngIf="data.type == 'question'" class="flex flex-row justify-center text-lg mt-4">
  <button mat-flat-button mat-dialog-close color="accent" (click)="logoutUser()">{{ data.yes | translatei18n }}</button>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>{{ data.no | translatei18n }}</button>
</mat-dialog-actions>
<mat-dialog-content *ngIf="data.type == 'choose'" class="flex flex-row justify-center text-center text-lg mt-4">
  <mat-slide-toggle mat-dialog-close [(ngModel)]="questionValue" (change)="onCheckboxChange($event)"> {{data.question}}</mat-slide-toggle>
</mat-dialog-content>
<mat-dialog-content *ngIf="data.type == 'choose'" class="flex flex-row justify-center text-center text-lg mt-4">
  <a [href]="getLink()" target="_blank">{{ data.bottomMessage }}</a>
</mat-dialog-content>
